import oil from "./images/oil.jpg";

export const sponser = {
    "data": {
        "sponsers": [
            {
                "id": 139,
                "isDeleted": false,
                "name": "TITLE SPONSOR",
                "priorty": 100,
                "sponsers": [
                    {
                        "id": 17,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/TITLE%20SPONSOR/1730131568.7341115.jpg",
                        "name": "Sham Exoctic Group",
                        "title": null,
                        "typeId": 139
                    }
                ]
            },
            {
                "id": 142,
                "isDeleted": false,
                "name": "POWERED BY",
                "priorty": 95,
                "sponsers": [
                    {
                        "id": 21,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/POWERED%20BY/1730190420.2811646.jpg",
                        "name": "Cnergy",
                        "title": null,
                        "typeId": 142
                    }
                ]
            },
            {
                "id": 150,
                "isDeleted": false,
                "name": "CO POWERED BY",
                "priorty": 94,
                "sponsers": [
                    {
                        "id": 29,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/CO%20POWERED%20BY/1730485811.3104968.jpg",
                        "name": "GoldMedal",
                        "title": null,
                        "typeId": 150
                    }
                ]
            },
            {
                "id": 144,
                "isDeleted": false,
                "name": "CO SPONSOR",
                "priorty": 85,
                "sponsers": [
                    {
                        "id": 49,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/CO%20SPONSOR/1730486232.6626925.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 144
                    },
                    {
                        "id": 70,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/CO%20SPONSOR/1730488750.0230317.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 144
                    }
                ]
            },
            {
                "id": 146,
                "isDeleted": false,
                "name": "ASSOCIATE SPONSOR",
                "priorty": 80,
                "sponsers": [
                    {
                        "id": 53,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/ASSOCIATE%20SPONSOR/1730486576.5555568.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 146
                    },
                    {
                        "id": 56,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/ASSOCIATE%20SPONSOR/1730486761.7803078.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 146
                    },
                    {
                        "id": 82,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/ASSOCIATE%20SPONSOR/1730887607.148993.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 146
                    }
                ]
            },
            {
                "id": 165,
                "isDeleted": false,
                "name": "Technical Partner",
                "priorty": 75,
                "sponsers": [
                    {
                        "id": 114,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/Technical%20Partner/1730909711.794157.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 165
                    }
                ]
            },
            {
                "id": 161,
                "isDeleted": false,
                "name": "BEVERAGE PARTNER",
                "priorty": 70,
                "sponsers": [
                    {
                        "id": 54,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/BEVERAGE%20PARTNER/1730486608.6927855.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 161
                    }
                ]
            },
            {
                "id": 159,
                "isDeleted": false,
                "name": "RADIO PARTNER",
                "priorty": 60,
                "sponsers": [
                    {
                        "id": 48,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/RADIO%20PARTNER/1730486199.3879626.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 159
                    }
                ]
            },
            {
                "id": 163,
                "isDeleted": false,
                "name": "BANKING PARTNER",
                "priorty": 50,
                "sponsers": [
                    {
                        "id": 71,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/BANKING%20PARTNER/1730489445.338686.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 163
                    }
                ]
            },
            {
                "id": 172,
                "isDeleted": false,
                "name": "Youth Banking Partner",
                "priorty": 47,
                "sponsers": [
                    {
                        "id": 110,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/Youth%20Banking%20Partner/1730890342.8952057.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 172
                    }
                ]
            },
            {
                "id": 173,
                "isDeleted": false,
                "name": "NEWS PARTNER",
                "priorty": 46,
                "sponsers": [
                    {
                        "id": 113,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/NEWS%20PARTNER/1730891706.7783606.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 173
                    }
                ]
            },
            {
                "id": 164,
                "isDeleted": false,
                "name": "EVENT PARTNER",
                "priorty": 45,
                "sponsers": [
                    {
                        "id": 73,
                        "isDeleted": false,
                        "link": oil,
                        "name": null,
                        "title": null,
                        "typeId": 164
                    },
                    {
                        "id": 74,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/EVENT%20PARTNER/1730737752.1370797.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 164
                    },
                    {
                        "id": 83,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/EVENT%20PARTNER/1730887683.9410553.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 164
                    },
                    {
                        "id": 92,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/EVENT%20PARTNER/1730888684.8777592.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 164
                    },
                    {
                        "id": 95,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/EVENT%20PARTNER/1730888856.0323622.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 164
                    },
                    {
                        "id": 96,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/EVENT%20PARTNER/1730888886.6672087.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 164
                    },
                    {
                        "id": 98,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/EVENT%20PARTNER/1730889112.6317084.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 164
                    }
                ]
            },
            {
                "id": 147,
                "isDeleted": false,
                "name": "MEDIA PARTNER",
                "priorty": 45,
                "sponsers": [
                    {
                        "id": 23,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/MEDIA%20PARTNER/1730192782.7698002.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 147
                    },
                    {
                        "id": 81,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/MEDIA%20PARTNER/1730887562.3724406.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 147
                    },
                    {
                        "id": 101,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/MEDIA%20PARTNER/1730889458.8384354.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 147
                    }
                ]
            },
            {
                "id": 158,
                "isDeleted": false,
                "name": "MERCHANDISE PARTNER",
                "priorty": 40,
                "sponsers": [
                    {
                        "id": 46,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/MERCHANDISE%20PARTNER/1730486158.0138712.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 158
                    }
                ]
            },
            {
                "id": 160,
                "isDeleted": false,
                "name": "GIFTING PARTNER",
                "priorty": 30,
                "sponsers": [
                    {
                        "id": 52,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/GIFTING%20PARTNER/1730486500.9950287.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 160
                    },
                    {
                        "id": 75,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/GIFTING%20PARTNER/1730737917.9129126.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 160
                    }
                ]
            },
            {
                "id": 167,
                "isDeleted": false,
                "name": "MOMENT PARTNER",
                "priorty": 25,
                "sponsers": [
                    {
                        "id": 94,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/MOMENT%20PARTNER/1730888735.6351385.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 167
                    }
                ]
            },
            {
                "id": 148,
                "isDeleted": false,
                "name": "CORPORATE PARTNER",
                "priorty": 20,
                "sponsers": [
                    {
                        "id": 26,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/CORPORATE%20PARTNER/1730192955.4736848.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 148
                    },
                    {
                        "id": 37,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/CORPORATE%20PARTNER/1730485925.6816988.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 148
                    },
                    {
                        "id": 50,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/CORPORATE%20PARTNER/1730486268.3851173.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 148
                    },
                    {
                        "id": 57,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/CORPORATE%20PARTNER/1730486773.0083523.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 148
                    },
                    {
                        "id": 58,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/CORPORATE%20PARTNER/1730486801.6872568.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 148
                    },
                    {
                        "id": 61,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/CORPORATE%20PARTNER/1730486903.0268843.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 148
                    },
                    {
                        "id": 62,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/CORPORATE%20PARTNER/1730487037.3767104.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 148
                    },
                    {
                        "id": 76,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/CORPORATE%20PARTNER/1730886725.8947961.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 148
                    },
                    {
                        "id": 80,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/CORPORATE%20PARTNER/1730887416.4991224.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 148
                    },
                    {
                        "id": 86,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/CORPORATE%20PARTNER/1730888292.207207.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 148
                    },
                    {
                        "id": 90,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/CORPORATE%20PARTNER/1730888550.600317.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 148
                    },
                    {
                        "id": 97,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/CORPORATE%20PARTNER/1730889073.1933532.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 148
                    },
                    {
                        "id": 104,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/CORPORATE%20PARTNER/1730889644.6222756.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 148
                    },
                    {
                        "id": 112,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/CORPORATE%20PARTNER/1730891669.031865.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 148
                    }
                ]
            },
            {
                "id": 149,
                "isDeleted": false,
                "name": "FOOD PARTNER",
                "priorty": 10,
                "sponsers": [
                    {
                        "id": 24,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/FOOD%20PARTNER/1730192886.150331.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 149
                    },
                    {
                        "id": 25,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/FOOD%20PARTNER/1730192907.4301949.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 149
                    },
                    {
                        "id": 38,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/FOOD%20PARTNER/1730485970.4610767.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 149
                    },
                    {
                        "id": 40,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/FOOD%20PARTNER/1730485995.158251.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 149
                    },
                    {
                        "id": 41,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/FOOD%20PARTNER/1730486006.7335856.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 149
                    },
                    {
                        "id": 42,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/FOOD%20PARTNER/1730486020.5217366.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 149
                    },
                    {
                        "id": 43,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/FOOD%20PARTNER/1730486115.2165084.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 149
                    },
                    {
                        "id": 44,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/FOOD%20PARTNER/1730486135.1591911.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 149
                    },
                    {
                        "id": 45,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/FOOD%20PARTNER/1730486150.9327703.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 149
                    },
                    {
                        "id": 47,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/FOOD%20PARTNER/1730486166.6032715.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 149
                    },
                    {
                        "id": 51,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/FOOD%20PARTNER/1730486460.8839643.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 149
                    },
                    {
                        "id": 55,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/FOOD%20PARTNER/1730486633.689215.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 149
                    },
                    {
                        "id": 59,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/FOOD%20PARTNER/1730486875.2757666.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 149
                    },
                    {
                        "id": 60,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/FOOD%20PARTNER/1730486887.2808585.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 149
                    },
                    {
                        "id": 69,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/FOOD%20PARTNER/1730488692.314084.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 149
                    },
                    {
                        "id": 84,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/FOOD%20PARTNER/1730887733.938418.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 149
                    },
                    {
                        "id": 108,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/FOOD%20PARTNER/1730890045.410252.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 149
                    }
                ]
            },
            {
                "id": 174,
                "isDeleted": false,
                "name": "CSR Partner",
                "priorty": 1,
                "sponsers": [
                    {
                        "id": 115,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/CSR%20Partner/1730916012.121369.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 174
                    }
                ]
            },
            {
                "id": 175,
                "isDeleted": false,
                "name": "Travel Partner",
                "priorty": 1,
                "sponsers": [
                    {
                        "id": 116,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/Travel%20Partner/1730959213.5365462.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 175
                    }
                ]
            },
            {
                "id": 171,
                "isDeleted": false,
                "name": "Engagement Partner",
                "priorty": 1,
                "sponsers": [
                    {
                        "id": 109,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/Engagement%20Partner/1730890233.7331228.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 171
                    }
                ]
            },
            {
                "id": 168,
                "isDeleted": false,
                "name": "TATTOOS PARTNER",
                "priorty": 1,
                "sponsers": [
                    {
                        "id": 99,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/TATTOOS%20PARTNER/1730889209.8879793.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 168
                    }
                ]
            },
            {
                "id": 166,
                "isDeleted": false,
                "name": "STORE PARTNER",
                "priorty": 1,
                "sponsers": [
                    {
                        "id": 85,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/STORE%20PARTNER/1730888126.286097.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 166
                    }
                ]
            },
            {
                "id": 162,
                "isDeleted": false,
                "name": "KRAFT STREET PARTNER",
                "priorty": 1,
                "sponsers": [
                    {
                        "id": 65,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/KRAFT%20STREET%20PARTNER/1730488366.6097171.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 162
                    },
                    {
                        "id": 66,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/KRAFT%20STREET%20PARTNER/1730488380.0011787.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 162
                    },
                    {
                        "id": 79,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/KRAFT%20STREET%20PARTNER/1730887359.0518186.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 162
                    },
                    {
                        "id": 88,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/KRAFT%20STREET%20PARTNER/1730888437.5107973.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 162
                    },
                    {
                        "id": 100,
                        "isDeleted": false,
                        "link": "https://storage.googleapis.com/pecfest/website2024/sponser/KRAFT%20STREET%20PARTNER/1730889371.9295168.jpg",
                        "name": null,
                        "title": null,
                        "typeId": 162
                    }
                ]
            }
        ]
    },
    "message": "Sponsers Fetched successfully",
    "status": "SUCCESS",
    "statusCode": 200
}